import { render, staticRenderFns } from "./CTAs.vue?vue&type=template&id=e0779a68&scoped=true&"
import script from "./CTAs.vue?vue&type=script&lang=js&"
export * from "./CTAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0779a68",
  null
  
)

export default component.exports